var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 200,
    viewBox: "0 0 257 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.305 15C200.709 15 192.654 19.143 185.71 26.3752C178.767 19.143 170.712 15 162.115 15C153.519 15 145.464 19.143 138.52 26.3752C131.577 19.143 123.522 15 114.926 15C106.329 15 98.2742 19.143 91.3307 26.3752C84.3873 19.143 76.3322 15 67.7359 15C59.1395 15 51.0845 19.143 44.141 26.3752C37.1975 19.143 29.1425 15 20.5461 15C11.9498 15 3.89475 19.143 -3.04874 26.3752C-9.95613 19.143 -18.0112 15 -26.6075 15C-52.6636 15 -73.79 53.0593 -73.79 100.004C-73.79 146.948 -52.6636 185.007 -26.6075 185.007C-18.0112 185.007 -9.95615 180.864 -3.01266 173.632C3.93083 180.864 11.9859 185.007 20.5822 185.007C29.1786 185.007 37.2336 180.864 44.1771 173.632C51.1206 180.864 59.1756 185.007 67.772 185.007C76.3683 185.007 84.4233 180.864 91.3668 173.632C98.3103 180.864 106.365 185.007 114.962 185.007C123.558 185.007 131.613 180.864 138.557 173.632C145.5 180.864 153.555 185.007 162.151 185.007C170.748 185.007 178.803 180.864 185.746 173.632C192.69 180.864 200.745 185.007 209.341 185.007C235.397 185.007 256.524 146.948 256.524 100.004C256.524 53.0593 235.361 15 209.305 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 170,
    fill: "white",
    transform: "translate(0 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/WebIcon.fbf60be39651a7f99d5dfa3549a684df.svg";
export { ForwardRef as ReactComponent };